const formatFlagType = (type) => type.replace(/_/g, " ");

export default formatFlagType;
